import {Forms} from '../forms/Forms';

export class InfoService {

    SERVICE_GETINFO = '../../onlinecommon/web/getInfo.php';

    public constructor(callback: any) {
        this.get(callback);
    }

    private get(callback: any): void {
        Forms.ajax(this.SERVICE_GETINFO, [], (obj: XMLHttpRequest) => {
            if (obj.responseText.length) {
                callback(JSON.parse(obj.responseText));
            }
        }, 'GET');
    }
}
